module.exports = __webpack_public_path__ + "static/media/6e9aff46-c1a4-44b5-89cd-c4796f25ac08_1.db2e5d9b9717e2fcfdff5a95e0593c6f.4ecb97d7.jpeg";